export default __webpack_public_path__ + "static/media/bkg--home-2.54a494a2.jpg";